import styled from "styled-components";
import {
  Avatar as AntAvatar,
  Badge as AntBadge,
  Input as AntInput,
  Button as AntButton,
} from "antd";

export const Space = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 32px;
`;

export const Avatar = styled(AntAvatar)`
  border: 2px solid #71207c;
`;

export const Badge = styled(AntBadge)`
  .ant-badge-count {
    height: auto;
    width: 80px;
    border-radius: 5px;
    box-shadow: none;
    background: linear-gradient(180deg, #fff987, #d69c17);
    font-size: 11px;
    font-weight: normal;
    color: #670000;
    margin-top: 36px;
    margin-bottom: 32px;
  }
`;

export const InputLabel = styled.p`
  font-size: 16px;
  width: 100%;
  margin: 0px;
  padding: 0px;
  margin-left: 16px;
  color: ${(props) => props.theme.dark1};
`;

export const Input = styled(AntInput)`
  margin-top: 4px;
  margin-bottom: 32px;
  border: 1px solid #e1cce0;
  height: 52px;
  border: 1px solid #e1cce0;
  border-radius: 8px;
  && {
    font-weight: 600;
    color: ${(props) => props.theme.textColor};
  }
`;

export const FileInput = styled.input`
  display: none;
`;

export const RootContainer = styled.div`
  position: relative;
  padding: 24px 16px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: ${(props) => props.theme.background};
`;

export const Button = styled(AntButton)`
  height: 56px;
  border: none;
  font-weight: 600;
  width: 100%;
  .ant-btn {
    animation: none !important;
  }
  @media screen and (max-height: 800px) {
    margin-top: 100px;
  }
  margin-top: 250px;
  border-radius: 12px;
  background: ${(props) => props.theme.primaryGradient} !important;
  :hover {
    background: ${(props) => props.theme.goldenVertical} !important;
  }
`;

export const SaveText = styled.div`
  color: ${(props) => props.theme.textColor};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const ProfileCard = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const ProfileImg = styled(AntAvatar)`
  color: ${(props) => props.theme.primarySolid};
  width: 100px;
  height: 100px;
  border-radius: 12px;
  font-weight: bold;
  font-size: 2em;
  object-fit: cover;
  overflow: hidden;
  background-color: ${(props) => props.theme.dark3};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LevelStatus = styled.p`
  width: 100%;
  margin: 0;
  border-radius: 0px 0px 12px 12px;
  background-color: #fbb52f;
  position: absolute;
  bottom: 0;
  color: white;
  font-size: 13px;
  text-align: center;
`;
